import axiosInstance from "../Shared/Utils/axiosInstance";
import { TokenDecrypt } from "../Shared/Utils/encryptionDecryption";

export const mappingFunction = (data, id, name) => {
  const decryptedData = TokenDecrypt(data);
  return decryptedData.map((item) => {
    return { value: item.id, label: item.name, ...item };
  });
};

export const getAllFamilyDistrict = async (languageId, stateId) => {
  try {
    const response = await axiosInstance.get(
      `/masterRouter/district/list?languageId=${languageId}&stateId=${stateId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, "districtId", "districtName");
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const getAllFamilyTaluka = async (languageId, districtId) => {
  try {
    const response = await axiosInstance.get(
      `/masterRouter/taluka/list?languageId=${languageId}&districtId=${districtId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, "talukaId", "talukaName");
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const getAllFamilyUphcOrPhc = async (
  languageId,
  districtId,
  talukaId,
  areaId,
  lgbId, 
  corporationHead = ""
) => {
  let url;
  try {    
    const areaType = (areaId === "Urban" || areaId === "शहरी") ? 1 : 2;
    
    url = `/masterRouter/phc/list?languageId=${languageId}&areaId=${areaType}`;
    const lgbTalukaCondition = () => {
      if (areaType === 2) {
        return `&districtId=${districtId}&talukaId=${talukaId}`;
      } else if (areaType === 1 && lgbId === 1) {
        return `&districtId=${districtId}&talukaId=${talukaId}&lgbId=${lgbId}`;
      } else if (areaType === 1 && !lgbId && !talukaId) {
        return `&corporation_council_id=${corporationHead}`;
      } else {
        return `&districtId=${districtId}&lgbId=${lgbId}`;
      }
    };
    url = url + lgbTalukaCondition();
    const response = await axiosInstance.get(url);
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, "phcId", "phcName");
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const getAllFamilyVillageOrSubarea = async (
  languageId,
  subCenterId,
  phcId
) => {
  try {
    const response = await axiosInstance.get(
      `/masterRouter/village/list?languageId=${languageId}&subCenterId=${subCenterId}&phcId=${phcId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, "villageId", "villageName");
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const getAllFamilySubcenter = async (languageId, phcId) => {
  try {
    const response = await axiosInstance.get(
      `/masterRouter/subCenter/list?languageId=${languageId}&phcId=${phcId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(
        response.data.data,
        "subcenterId",
        "SubcenterName"
      );
    }
    throw new Error("Failed to fetch subCenters");
  } catch (error) {
    return [];
  }
};

export const getAllFamilyLgb = async (languageId, areaType) => {
  try {
    const areaId = (areaType === "Urban" || areaType === "शहरी") ? 1 : 2;

    const response = await axiosInstance.get(
      `/masterRouter/localGoverningBody/list?languageId=${languageId}&areaId=${areaId}`
    );
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, "lgbId", "lgbName");
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const getAllFamilyEligibleCouple = async (
  languageId,
  districtId,
  talukaId,
  phcId,
  subcenterId,
  villageId,
  lgbId,
  areaType,
  uphcId,
  subareaId,
  corporationHead,
  page,
  pageSize
) => {
  try {
    const accessLevel = [
      // English
      { id: 1, name: "State" },
      { id: 2, name: "District" },
      { id: 3, name: "Taluka" },
      { id: 4, name: "PHC" },
      { id: 5, name: "UPHC" },
      { id: 6, name: "Corporation" },
      { id: 7, name: "Multi District" },
    ];

    const access_level_id = sessionStorage.getItem("access_level_id");

    const filteredAccessLevel = accessLevel.filter(
      (level) => level.id === Number(access_level_id)
    );

    const accessLevelName = filteredAccessLevel[0].name;


  const areaId = (areaType === "Urban" || areaType === "शहरी") ? 1 : 2;
    let url = `/api/families/count?page=${page}&pageSize=${pageSize}&languageId=${languageId}&areaId=${areaId}`;
    const queryParams = () => {
      if (accessLevelName === "State") {
        if (
          !districtId &&
          !talukaId &&
          !phcId &&
          !lgbId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return "stateId=1";
        } else if (
          districtId &&
          !talukaId &&
          !phcId &&
          !lgbId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `districtId=${districtId}`;
        } else if (
          districtId &&
          talukaId &&
          !phcId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `talukaId=${talukaId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          !subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `phcId=${phcId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `subCenterId=${subcenterId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          villageId &&
          areaId === 2
        ) {
          return `villageId=${villageId}`;
        } else if (
          districtId &&
          lgbId &&
          !talukaId &&
          !uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `lgbId=${lgbId}&districtId=${districtId}`;
        } else if (
          districtId &&
          lgbId &&
          uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (districtId && lgbId && uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      } else if (accessLevelName === "PHC") {
        if (
          !districtId &&
          !talukaId &&
          phcId &&
          !lgbId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId &&
          areaId === 2
        ) {
          return `phcId=${phcId}`;
        } else if (
          !districtId &&
          !talukaId &&
          phcId &&
          subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `subCenterId=${subcenterId}`;
        } else if (
          !districtId &&
          !talukaId &&
          phcId &&
          subcenterId &&
          villageId &&
          areaId === 2
        ) {
          return `villageId=${villageId}`;
        }
      } else if (accessLevelName === "District" || accessLevelName === "Multi District") {
        if (
          districtId &&
          !talukaId &&
          !phcId &&
          !lgbId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `districtId=${districtId}`;
        } else if (
          districtId &&
          talukaId &&
          !phcId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `talukaId=${talukaId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          !subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `phcId=${phcId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `subCenterId=${subcenterId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          villageId &&
          areaId === 2
        ) {
          return `villageId=${villageId}`;
        } else if (
          districtId &&
          lgbId &&
          !talukaId &&
          !uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `lgbId=${lgbId}&districtId=${districtId}`;
        } else if (
          districtId &&
          lgbId &&
          uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (districtId && lgbId && uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      } else if (accessLevelName === "Taluka") {
        if (
          districtId &&
          talukaId &&
          !phcId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `talukaId=${talukaId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          !subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `phcId=${phcId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `subCenterId=${subcenterId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          villageId &&
          areaId === 2
        ) {
          return `villageId=${villageId}`;
        } else if (
          districtId &&
          lgbId &&
          talukaId &&
          !uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `lgbId=${lgbId}&districtId=${districtId}`;
        } else if (
          districtId &&
          lgbId &&
          talukaId &&
          !uphcId &&
          !subareaId &&
          lgbId === 1 &&
          areaId === 1
        ) {
          return `talukaId=${talukaId}`;
        } else if (
          districtId &&
          lgbId &&
          uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (districtId && lgbId && uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      } else if (accessLevelName === "Corporation") {
        if (
          corporationHead &&
          !uphcId &&
          !subareaId
        ) {
          return `corporation_council_id=${corporationHead}`;
        } else if (
          corporationHead &&
          uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (corporationHead && uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      } else if (accessLevelName === "UPHC") {
        if (
          uphcId && !subareaId && areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      } 
    };
    const newUrl = url + "&" + queryParams();
    const response = await axiosInstance.get(newUrl);

    if (response.status === 200 && response.data && response.data.data) {
      return TokenDecrypt(response.data.data);
    }
    if (response.status === 404) {
      return [];
    }
    throw new Error("Failed to fetch familiesAndEligibleCouplesCount");
  } catch (error) {
    if (error.status === 404) {
      return [];
    }
    throw new Error(
      error.message || "Failed to fetch familiesAndEligibleCouplesCount"
    );
  }
};

export const getAllFamilyStatistics = async (
  languageId,
  districtId,
  talukaId,
  phcId,
  subcenterId,
  villageId,
  lgbId,
  areaType,
  uphcId,
  subareaId,
  corporationHead
) => {
  try {
    const accessLevel = [
      // English
      { id: 1, name: "State" },
      { id: 2, name: "District" },
      { id: 3, name: "Taluka" },
      { id: 4, name: "PHC" },
      { id: 5, name: "UPHC" },
      { id: 6, name: "Corporation" },
      { id: 7, name: "Multi District" },
    ];

    const access_level_id = sessionStorage.getItem("access_level_id");

    const filteredAccessLevel = accessLevel.filter(
      (level) => level.id === Number(access_level_id)
    );

    const accessLevelName = filteredAccessLevel[0].name;

    const areaId = (areaType === "Urban" || areaType === "शहरी") ? 1 : 2;

    let url = `/api/families/statistics?languageId=${languageId}&areaId=${areaId}`;
    const queryParams = () => {
      if (accessLevelName === "State") {
        if (
          !districtId &&
          !talukaId &&
          !phcId &&
          !lgbId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return "stateId=1";
        } else if (
          districtId &&
          !talukaId &&
          !phcId &&
          !lgbId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `districtId=${districtId}`;
        } else if (
          districtId &&
          talukaId &&
          !phcId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `talukaId=${talukaId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          !subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `phcId=${phcId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `subCenterId=${subcenterId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          villageId &&
          areaId === 2
        ) {
          return `villageId=${villageId}`;
        } else if (
          districtId &&
          lgbId &&
          !talukaId &&
          !uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `lgbId=${lgbId}&districtId=${districtId}`;
        } else if (
          districtId &&
          lgbId &&
          uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (districtId && lgbId && uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      } else if (accessLevelName === "PHC") {
        if (
          !districtId &&
          !talukaId &&
          phcId &&
          !lgbId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId &&
          areaId === 2
        ) {
          return `phcId=${phcId}`;
        } else if (
          !districtId &&
          !talukaId &&
          phcId &&
          subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `subCenterId=${subcenterId}`;
        } else if (
          !districtId &&
          !talukaId &&
          phcId &&
          subcenterId &&
          villageId &&
          areaId === 2
        ) {
          return `villageId=${villageId}`;
        }
      } else if (accessLevelName === "District" || accessLevelName === "Multi District") {
        if (
          districtId &&
          !talukaId &&
          !phcId &&
          !lgbId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `districtId=${districtId}`;
        } else if (
          districtId &&
          talukaId &&
          !phcId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `talukaId=${talukaId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          !subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `phcId=${phcId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `subCenterId=${subcenterId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          villageId &&
          areaId === 2
        ) {
          return `villageId=${villageId}`;
        } else if (
          districtId &&
          lgbId &&
          !talukaId &&
          !uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `lgbId=${lgbId}&districtId=${districtId}`;
        } else if (
          districtId &&
          lgbId &&
          uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (districtId && lgbId && uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      } else if (accessLevelName === "Taluka") {
        if (
          districtId &&
          talukaId &&
          !phcId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `talukaId=${talukaId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          !subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `phcId=${phcId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `subCenterId=${subcenterId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          villageId &&
          areaId === 2
        ) {
          return `villageId=${villageId}`;
        } else if (
          districtId &&
          lgbId &&
          !talukaId &&
          !uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `lgbId=${lgbId}&districtId=${districtId}`;
        } else if (
          districtId &&
          lgbId &&
          talukaId &&
          !uphcId &&
          !subareaId &&
          lgbId === 1 &&
          areaId === 1
        ) {
          return `talukaId=${talukaId}`;
        } else if (
          districtId &&
          lgbId &&
          uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (districtId && lgbId && uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      }  else if (accessLevelName === "Corporation") {
        if (
          corporationHead &&
          !uphcId &&
          !subareaId
        ) {
          return `corporation_council_id=${corporationHead}`;
        } else if (
          corporationHead &&
          uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (corporationHead && uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      } else if (accessLevelName === "UPHC") {
        if (
          uphcId && !subareaId && areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      } 
    };
    const newUrl = url + "&" + queryParams();
    const response = await axiosInstance.get(newUrl);

    if (response.status === 200 && response.data && response.data.data) {
      return TokenDecrypt(response.data.data);
    }
    throw new Error("Failed to fetch familiesAndEligibleCouplesCount");
  } catch (error) {
    throw new Error(
      error.message || "Failed to fetch familiesAndEligibleCouplesCount"
    );
  }
};
